import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyDigitalFormsunauthorizedaccesssvg = lazy(
  () => import('./svg-components/digital-forms-unauthorized-access-svg')
);

const DigitalFormsUnauthorizedAccessSvg = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyDigitalFormsunauthorizedaccesssvg {...rest} />
  </Suspense>
);

export default DigitalFormsUnauthorizedAccessSvg;
